<template>
    <div id="policyWrap">
        <!-- <div class="fixedIconBox" @click="toForm">
            <span class="titleText">政策了解</span>
        </div>
        
        <img src="../../images/policy/policy1.jpg" alt="" @click="toForm" />
        <img src="../../images/policy/policy2.jpg" alt="" />
        <div class="twoImg">
            <img src="../../images/policy/policy3.jpg" alt="" />
            <img src="../../images/policy/policy4.jpg" alt="" />
        </div>
        <img src="../../images/policy/policy5.jpg" alt="" />
        <div class="longBtnBox">
            <button class="btn-red btn-long btn-shadow" @click="toForm">政策了解</button>
        </div> -->
        <div class="fixedIconBox" @click="toForm">
            <span class="titleText">政策了解</span>
        </div>
        <div class="firstSection">
            <div class="backBtn" @click="back"  v-if="!isFromYjj">
                <i class="el-icon-arrow-left"></i> 返回
            </div>
            <img src="../../images/newImages/bg_zhengce.png" alt="">
            <div class="floatBox">
                <div class="title bold">服装产业相关政策</div>
                <div class="subtitle">
                        <button class="btn-yellow" @click="toForm">了解更多</button>
                </div>
            </div>
        
        </div>
        <div class="secondSection">
            <div class="title">余杭区相关政策</div>
            <div class="text">
                <ul class="textUl">
                    <li>
                        1、《余杭区“时尚产业新十条”政策》 
                    </li>
                     <li>
                        2、《余杭区家纺服装传统产业升级改造升级方案》
                    </li>
                     <li>
                        3、《余杭区“智能制造十条”政策》
                    </li>
                    
                </ul>
            </div>
        </div>
        <div class="fileSection">
            <el-row :gutter="12">
                <el-col :span="12">
                    <div class="tuwenBlock">
                        <div class="imgBox">
                            <img src="../../images/newImages/file1.png" alt="">
                        </div>
                        <div class="text">
                            时尚产业新十条
                        </div>
                          
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="tuwenBlock">
                        <div class="imgBox">
                            <img src="../../images/newImages/file2.png" alt="">
                        </div>
                        <div class="text">
                            智能制造新十条
                        </div>
                          
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="tuwenBlock">
                        <div class="imgBox">
                            <img src="../../images/newImages/file3.png" alt="">
                        </div>
                        <div class="text">
                            家纺服装传统产业改造升级方案
                        </div>
                          
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="tuwenBlock">
                        <div class="imgBox">
                            <img src="../../images/newImages/file4.png" alt="">
                        </div>
                        <div class="text">
                            全域创新策源地建设意见
                        </div>
                          
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {
        ajaxCode,
        ajaxLogin
    } from '@/assets/request.js'
    import {
        setCookie,
        phoneReg,
        codeReg,
        filterPhoneNum,
        GetRequest
    } from '@/assets/common.js'
    export default {
        data() {
            return {
                paramObj: {},
                phone: '',
                code: '',
                isFromYjj:'',

            }
        },
        methods: {
            back(){
              this.$router.back()  
            },
            toForm() {
                this.$router.push({
                    name: 'PolicyForm'
                });
            },
            login() {
                let _this = this
                ajaxLogin(_this.phone, _this.code).then(res => {

                    let token = JSON.parse(res.data).token
                    let userId = JSON.parse(res.data).userId
                    console.log(token, userId)
                    sessionStorage.setItem("isLogined", "1")
                    sessionStorage.setItem("token", token)
                    sessionStorage.setItem("userId", userId)
                    setCookie("global_token", token, 10)
                }, (res) => {})
            }
        },
        mounted() {
            this.paramObj = GetRequest()
            console.log(this.paramObj )
            this.phone = this.paramObj.p
            this.code = this.paramObj.c
            if (this.phone && this.code) {
                this.login()
            }
            
            this.isFromYjj=this.code?true:false
            console.log(this.isFromYjj,'是否来自衣加加')
        }
    }
</script>

<style lang="less" scoped="scoped">
    #policyWrap{
        .firstSection{
            img{width: 100%;} position: relative;
            .floatBox{
                color:#EFC996; font-size: 0.48rem; position: absolute; top:1.8rem; text-align: center; width: 100%;
                .subtitle{
                    button{
                        padding:0.21rem 0rem; width: 1.97rem;margin-top:0.6rem;
                    }
                }
            }
        }
        .secondSection{
            padding:0 0.4rem;
            padding-top:0.8rem; background: #fff;
            .title{
                font-size: 0.36rem; font-weight: bold; line-height: 0.68rem; margin-bottom:0.27rem;
            }
            .textUl{
                 padding-bottom: 0.6rem;  
                li{
                  font-size: 0.28rem;color:#666;line-height: 0.68rem;
                }
            }
        }
        .fileSection{
            padding:0 0.4rem; background: #fff; 
            .tuwenBlock{
                margin-bottom: 0.7rem;
                .imgBox{
                    img{width: 100%;}
                }
                .text{
                    font-size: 0.28rem; color:#333;margin-top:0.21rem; text-align: center; padding:0 0.3rem;
                }
            }
        }
            
    }
</style>



// WEBPACK FOOTER //
// src/page/introPage/policy.vue